import { render } from "./ConfiguracaoIA.vue?vue&type=template&id=54d55726&scoped=true"
import script from "./ConfiguracaoIA.vue?vue&type=script&lang=js"
export * from "./ConfiguracaoIA.vue?vue&type=script&lang=js"

import "./ConfiguracaoIA.vue?vue&type=style&index=0&id=54d55726&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54d55726"]])

export default __exports__